import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import PatternList from "./PatternList";
import styles from "./Dashboard.module.scss";
import { getCurrentProfile } from "../../actions/profileActions";
import NoProfile from "./NoProfile";
import ProfileActions from "./ProfileActions";
import { Container, Grid } from "semantic-ui-react";
import { Heading1 } from "../../components/value-cssmodules/TextComponent";
import Spinner from "../../components/Spinner";
import { authSelector, profileSelector } from "../../utils/selectors";
import isEmpty from "../../validation/is-empty";

const Dashboard = () => {
	const dispatch = useDispatch();

	const { profile, loading } = useSelector((state: any) =>
		profileSelector(state),
	);
	const { user } = useSelector((state: any) => authSelector(state));

	useEffect(() => {
		dispatch(getCurrentProfile());
	}, [dispatch]);

	if (loading) {
		return <Spinner />;
	}

	return (
		<Grid>
			<Container className={styles.self}>
				<Heading1>
			<FormattedMessage
				id="dashboard.title"
				defaultMessage="My patterns"
			/>
			</Heading1>
			{profile !== null && user ? (
					<div>
						<ProfileActions hasProfile={!isEmpty(profile)} />
						<PatternList />
					</div>
				) : (
					<NoProfile />
				)}
			</Container>
		</Grid>
	);
};

export default Dashboard;


